// extracted by mini-css-extract-plugin
export default {"Burger":"Burger_Burger__09v95","BurgerOpen":"Burger_BurgerOpen__GJYlQ","BurgerClosed":"Burger_BurgerClosed__OGPiG"};